import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@neo/primitives/base/select'
import type { AppSourceOption } from '../hooks/use-app-source-data'

interface AppSourceSelectorProps {
  selectedAppProvider: string
  selectedAppSourceId: string
  availableKnowledgeBaseSources: AppSourceOption[]
  onAppChange: (appId: string) => void
}

export const AppSourceSelector = ({
  selectedAppProvider,
  selectedAppSourceId,
  availableKnowledgeBaseSources,
  onAppChange,
}: AppSourceSelectorProps) => {
  // Find the selected app using the specific app source ID first, then fallback to provider
  const selectedApp = selectedAppSourceId
    ? availableKnowledgeBaseSources.find((app) => app.id === selectedAppSourceId)
    : availableKnowledgeBaseSources.find(
        (app) => app.provider === selectedAppProvider && app.isConnected,
      ) || availableKnowledgeBaseSources.find((app) => app.provider === selectedAppProvider)

  return (
    <div className="flex flex-col gap-2">
      <div className="text-s-500">Select data source</div>
      <Select value={selectedApp?.id || ''} onValueChange={onAppChange}>
        <SelectTrigger className="w-96" data-testid="select-app-source">
          <SelectValue placeholder="Select source">
            {selectedApp && (
              <div className="flex items-center gap-2">
                {selectedApp.logoUrl && (
                  <img
                    src={selectedApp.logoUrl}
                    alt={`${selectedApp.name} logo`}
                    className="h-5 w-5 object-contain"
                  />
                )}
                <span className="text-s-500">
                  {selectedApp.name}
                  {selectedApp.accountIdentifier && (
                    <span className="text-xs-400 text-muted-foreground">
                      {' '}
                      ({selectedApp.accountIdentifier})
                    </span>
                  )}
                </span>
              </div>
            )}
          </SelectValue>
        </SelectTrigger>
        <SelectContent>
          {availableKnowledgeBaseSources.map((app) => (
            <SelectItem key={app.id} value={app.id}>
              <div className="flex items-center gap-2">
                {app.logoUrl && (
                  <img
                    src={app.logoUrl}
                    alt={`${app.name} logo`}
                    className="h-5 w-5 object-contain"
                  />
                )}
                <span className="text-s-500">
                  {app.name}
                  {app.accountIdentifier && (
                    <span className="text-xs-400 text-muted-foreground">
                      {' '}
                      ({app.accountIdentifier})
                    </span>
                  )}
                </span>
              </div>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  )
}
